/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useRef } from 'react';
import { Navigate } from 'react-router-dom';
import { APP_ROUTES } from '../../appRoutes';
import { authStorage } from '../../utils/storage';
import api, { VERSION } from '../configuracion/config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUser,
  faKey
} from '@fortawesome/free-solid-svg-icons';
import './Login.css';

function Login() {
  const [Usuario, setUsername] = useState('');
  const [Password, setPassword] = useState('');
  const [loggedIn, setLoggedIn] = useState(false);
  const [error, setError] = useState('');
  const passwordInputRef = useRef(null);
  const loginButtonRef = useRef(null);

  const handleLogin = async () => {
    try {
      const response = await api.post('/login', {
        Usuario: Usuario,
        Password: Password,
      });

      if (response.status === 200) {
        setLoggedIn(true);
        authStorage.setUserSession({
          userId: response.data.strUsuario,
          userName: response.data.strNombres,
          userType: response.data.strTipo,
        });
      }
    } catch (err) {
      setError('Credenciales incorrectas. Por favor, inténtalo de nuevo.');
    }
  };

  const handleEnterPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (e.target === passwordInputRef.current) {
        loginButtonRef.current.focus();
      } else {
        passwordInputRef.current.focus();
      }
    }
  };

  if (loggedIn) {
    return <Navigate to={APP_ROUTES.inicio} />;
  }

  return (
    <div className="login-page d-flex align-items-center justify-content-center">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-8 col-lg-9 col-md-10" >
            <div className="card border-0 shadow-lg login-card">
              <div className="row g-0">
                <div className="col-md-5 login-brand-panel d-flex flex-column justify-content-center align-items-center p-4">
                  <img
                    src="./Logo.png"
                    className="img-fluid mb-3"
                    style={{ maxWidth: '180px',  }}
                  />
                  <h3 className="text-white mb-1">Minutas</h3>
                  <p className="text-white-50 text-center small mb-0">
                    Plataforma de registro y seguimiento
                  </p>
                </div>

                <div className="col-md-7">
                  <div className="card-body p-4 p-md-5">
                    <h5 className="text-secondary mb-1">Iniciar sesión</h5>
                    <p className="text-muted small mb-4">
                      Ingresa tus credenciales para continuar.
                    </p>

                    <form>
                      <div className="input-group mt-2">
                        <span className="input-group-text login-icon">
                          <FontAwesomeIcon icon={faUser} />
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          id="Usuario"
                          value={Usuario}
                          onChange={(e) => setUsername(e.target.value)}
                          placeholder="Ej. admin o ID del usuario"
                          onKeyPress={handleEnterPress}
                          autoComplete="username"
                        />
                      </div>

                      <div className="input-group mt-3">
                        <span className="input-group-text login-icon">
                          <FontAwesomeIcon icon={faKey} />
                        </span>
                        <input
                          type="password"
                          className="form-control"
                          id="Password"
                          value={Password}
                          onChange={(e) => setPassword(e.target.value)}
                          placeholder="Ingresa tu contraseña"
                          ref={passwordInputRef}
                          onKeyPress={handleEnterPress}
                          autoComplete="current-password"
                        />
                      </div>

                      {error && <p className="login-error mt-3 mb-0">{error}</p>}

                      <div className="d-grid mt-4">
                        <button
                          type="button"
                          className="btn btn-login"
                          onClick={handleLogin}
                          ref={loginButtonRef}
                        >
                          Ingresar
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <div className="text-center mt-3">
              <p className="small text-muted mb-0">
                ©{new Date().getFullYear()} versión {VERSION}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
